import person_icon from "~/assets/mainPage/Ico_Persone.svg";
import document_icon from "~/assets/mainPage/Ico_Doc.svg";
import ico_check from "~/assets/mainPage/Ico_Check.svg";
import logo_map from "~/assets/mainPage/cards/Map_Ukraine.svg";
import logo_fatca from "~/assets/mainPage/cards/Map_USA.svg";
import logo_crs from "~/assets/mainPage/cards/Logo_Tax.svg";
import logo_processing_personal_data from "~/assets/mainPage/cards/IMG_Data_560x160.jpg";
import logo_fop from "~/assets/mainPage/cards/IMG_FOP_560x260.jpg";
import logo_covenants_legal from "~/assets/mainPage/cards/IMG_Covenants.jpg";
import logo_covenants_fop from "~/assets/mainPage/cards/IMG_Covenants_FOP.jpg";
import logo_fop_reidentification from "~/assets/mainPage/cards/IMG_ReidentificationFop.jpg";
import logo_legal_reidentification from "~/assets/mainPage/cards/IMG_ReidentificationLegal.jpg";
import logo_dbo from "~/assets/mainPage/cards/IMG_DBO.jpg"
import logo_legal_resident from "~/assets/mainPage/cards/IMG_Legal_560x260.jpg";
import { openInstructionRemoteBankingContactsPDF } from '~/modules/main-page/utils.ts';

const covenantsBenefits = {
    title: 'Основні переваги:',
    items: [
        {
            title: 'Єдина точка відповідальності.',
            text: 'Компанія може призначити одну відповідальну особу для комунікації з Банком та завантаження документів. Це мінімізує ризик помилок і забезпечує чіткий контроль процесу.'
        },
        {
            title: 'Зручність для спеціалістів.',
            text: 'Профільні співробітники можуть надсилати документи в Банк у момент їх готовності та в будь‑який зручний час, без необхідності особистого відвідування відділення.'
        },
        {
            title: 'Доступність 24/7.',
            text: 'Веб‑портал працює цілодобово ‑ не потрібно орієнтуватися на графік роботи Банку. Доступ можливий із будь‑якого місця, де є інтернет.'
        },
        {
            title: 'Прозорість і контроль.',
            text: 'Підприємство може в режимі реального часу відстежувати статус приймання документів, бачити коментарі та зауваження Банку, а також оперативно їх усувати.'
        },
        {
            title: 'Економія часу та ресурсів.',
            text: 'Онлайн‑подання дозволяє підписувати документи КЕП керівника без зайвих формальностей, усуваючи потребу в ручному підписанні та завіренні копій.'
        },
        {
            title: 'Підтримувані розширення файлів.',
            text: '.7z, .bmp, .csv, .doc, .docx, .jpeg, .jpg, .m4a, .mp3, .mp4, .msg, .p7s, .pdf, .png, .ppt, .pptx, .rar, .rtf, .tiff, .tmp, .txt, .xls, .xlsx, .xml, .zip.'
        }
    ]
};

export const getRemoteBankingContactsCard = (
    isDBOEnabled,
    handleRemoteBankingContacts,
    openInstructionRemoteBankingContactsPDF
) => ({
    flagKey: isDBOEnabled,
    imageSrc: logo_dbo,
    imageAlt: 'processing_personal_data',
    styleCard: false,
    title: 'ДБО',
    description: 'Нова система дистанційного банківського обслуговування Exim Business',
    primaryButtonText: 'Реєстрація',
    primaryButtonAction: handleRemoteBankingContacts,
    primaryButtonAdditionally: false,
    dropdownButtons: [
        {
            text: 'Інструкція',
            action: openInstructionRemoteBankingContactsPDF
        }
    ]
});

export const getGuaranteesCard = (
    isGuaranteesEnabled,
    handleOpenGuarantees
) => ({
    flagKey: isGuaranteesEnabled,
    imageSrc: logo_covenants_legal,
    imageAlt: 'guarantees_banner',
    styleCard: false,
    singleLineTitle: true,
    widePrimaryButton: true,
    title: 'Видача гарантій',
    description: '• пошук контрагента онлайн\n' +
        '• швидкий перехід до сервісу\n' +
        '• подальший функціонал буде доступний пізніше',
    primaryButtonText: 'Перейти',
    primaryButtonAction: handleOpenGuarantees,
});

export const mainCardsLegalResident = (
    isDBOEnabled,
    handleRemoteBankingContacts,
    handleOpenCovenants,
    handleReidentification,
    openInstructionReIdentificationLegalResident,
    openInstructionCovenantsPDF,
    isGuaranteesEnabled,
    handleOpenGuarantees,
    isUpdatingDataLegalResidentEnabled,
    handleUpdatingData,
) => [
    {
        flagKey: true,
        imageSrc: logo_legal_reidentification,
        imageAlt: 'legal_reidentification',
        styleCard: false,
        widePrimaryButton: true,
        title: 'Повторна ідентифікація',
        description: 'Пройдіть повторну ідентифікацію згідно вимог законодавства про фінансовий моніторинг якщо:\n' +
            '• змінювалися дані\n' +
            '• банк запросив оновлення',
        primaryButtonText: 'Заповнити анкету',
        primaryButtonAction: handleReidentification,
        dropdownButtons: [
            {
                text: 'Інструкція',
                action: openInstructionReIdentificationLegalResident
            }
        ]
    },
    {
        flagKey: true,
        imageSrc: logo_covenants_legal,
        imageAlt: 'resident_covenants',
        styleCard: false,
        singleLineTitle: true,
        widePrimaryButton: true,
        title: 'Виконання умов кредитних договорів',
        description: '• керуйте кредитними договорами онлайн\n' +
            '• передавайте документи\n' +
            '• відстежуйте статус виконання',
        primaryButtonText: 'Передати документи',
        primaryButtonAction: handleOpenCovenants,
        dropdownButtons: [
            {
                text: 'Інструкція',
                action: openInstructionCovenantsPDF
            }
        ],
        expandableInfo: covenantsBenefits,
    },
    getRemoteBankingContactsCard(isDBOEnabled, handleRemoteBankingContacts, openInstructionRemoteBankingContactsPDF),
    getGuaranteesCard(isGuaranteesEnabled, handleOpenGuarantees),
    {
        flagKey: isUpdatingDataLegalResidentEnabled,
        imageSrc: logo_legal_resident,
        imageAlt: 'logo_legal_resident',
        styleCard: false,
        title: 'Оновлення даних для Юридичної особи',
        description: 'текст',
        primaryButtonText: 'Оновити',
        primaryButtonAction: handleUpdatingData,
        dropdownButtons: [
            {
                text: 'Інструкція',
                action: () => {}
            }
        ],
    },
];

export const mainCardsSoleTrader = (
    isDBOEnabled,
    handleRemoteBankingContacts,
    handleCheckUserRegistration,
    handleRate,
    openInstructionSoleTraderPDF,
    handleReidentification,
    handleOpenCovenants,
    openInstructionReIdentificationFopPDF,
    openInstructionCovenantsPDF,
    isGuaranteesEnabled,
    handleOpenGuarantees,
    isUpdatingDataFopEnabled,
    handleUpdatingData,
) => [
    {
        flagKey: true,
        imageSrc: logo_fop,
        imageAlt: 'fop',
        styleCard: false,
        title: 'Рахунок онлайн для Фізичної особи',
        description: 'Подавайте документи онлайн та відкривайте рахунок ФОП без відвідування відділень, черг і зайвих паперів. Лише кілька кліків - рахунок відкрито.',
        primaryButtonText: 'Відкрити',
        primaryButtonAction: handleCheckUserRegistration,
        dropdownButtons: [
            {
                text: 'Інструкція',
                action: openInstructionSoleTraderPDF
            },
            {
                text: 'Тарифи',
                action: handleRate
            },
        ]
    },
    {
      flagKey: true,
      imageSrc: logo_fop_reidentification,
      imageAlt: 'fop_reidentification',
      styleCard: false,
      widePrimaryButton: true,
      title: 'Повторна ідентифікація',
      description: 'Пройдіть повторну ідентифікацію згідно вимог законодавства про фінансовий моніторинг якщо:\n' +
          '• змінювалися дані\n' +
          '• банк запросив оновлення',
      primaryButtonText: 'Заповнити анкету',
      primaryButtonAction: handleReidentification,
      dropdownButtons: [
        {
          text: 'Інструкція',
          action: openInstructionReIdentificationFopPDF
        }
      ]
    },
    {
        flagKey: true,
        imageSrc: logo_covenants_fop,
        imageAlt: 'fop_covenants',
        styleCard: true,
        singleLineTitle: true,
        widePrimaryButton: true,
        title: 'Виконання умов кредитних договорів',
        description: '• керуйте кредитними договорами онлайн\n' +
            '• передавайте документи\n' +
            '• відстежуйте статус виконання',
        primaryButtonText: 'Передати документи',
        primaryButtonAction: handleOpenCovenants,
        dropdownButtons: [
            {
                text: 'Інструкція',
                action: openInstructionCovenantsPDF
            }
        ],
        expandableInfo: covenantsBenefits,
    },
    getRemoteBankingContactsCard(isDBOEnabled, handleRemoteBankingContacts, openInstructionRemoteBankingContactsPDF),
    getGuaranteesCard(isGuaranteesEnabled, handleOpenGuarantees),
    {
        flagKey: isUpdatingDataFopEnabled,
        imageSrc: logo_fop,
        imageAlt: 'fop',
        styleCard: false,
        title: 'Оновлення даних для Фізичної особи',
        description: 'текст',
        primaryButtonText: 'Оновити',
        primaryButtonAction: handleUpdatingData,
        dropdownButtons: [
            {
                text: 'Інструкція',
                action: () => {}
            },
        ]
    },
];

export const mainCardsCounterParty = (handleProcessingPersonalDataForm, handleRevokeProcessingPersonalDataForm, openInstructionProcessingPersonalClient) => [
    {
        flagKey: true,
        imageSrc: logo_processing_personal_data,
        imageAlt: 'processing_personal_data',
        styleCard: false,
        title: 'Згода на обробку персональних даних',
        description: 'Сервіс доступний за умови встановленого застосунку Дія на мобільному пристрої та наявності ID-картки або закордонного паспорта громадянина України',
        primaryButtonText: 'Надати',
        primaryButtonAction: handleProcessingPersonalDataForm,
        primaryButtonAdditionally: true,
        primaryButtonAdditionallyText: 'Відкликати',
        primaryButtonAdditionallyAction: handleRevokeProcessingPersonalDataForm,
        dropdownButtons: [
            {
                text: 'Інструкція',
                action: openInstructionProcessingPersonalClient
            }
        ]
    }
];

export const additionallyCards = (openDirectoryOrgUa, openFatca, openCRS) => [
    {
        imageSrc: logo_map,
        imageAlt: 'map',
        title: 'КАТОТТГ',
        description: 'Кодифікатор адміністративно-територіальних одиниць та територій територіальних громад',
        primaryButtonAction: openDirectoryOrgUa,
    },
    {
        imageSrc: logo_fatca,
        imageAlt: 'fatca',
        title: 'FATCA',
        description: 'Інформація щодо Закону США «Про податкові вимоги до закордонних рахунків»',
        primaryButtonAction: openFatca,
    },
    {
        imageSrc: logo_crs,
        imageAlt: 'crs',
        title: 'CRS',
        description: 'Практичні питання тлумачення окремих термінів Загального стандарту звітності',
        primaryButtonAction: openCRS,
    },
];

export const informationCard = [
    {
        imageSrc1: person_icon,
        imageAlt1: 'map',
        title1: "Вимоги до юридичної особи:",
        items1: [
            {
                text: "Наявність КЕП/УЕП юридичної особи будь-якого надавача довірчих послуг",
                imageSrc: ico_check,
                imageAlt: 'ico_check',
            },
            {
                text: `Рекомендовано встановлення застосунку Дія на мобільний пристрій Керівника та Розпорядників`,
                imageSrc: ico_check,
                imageAlt: 'ico_check',
            },
        ],

        imageSrc2: document_icon,
        imageAlt2: 'map',
        title2: "Перелік необхідних електронних документів (PDF, DOCX, XLSX, JPG):",
        items2: [
            {
                title: "1. Установчі документи:",
                li: [
                    { text: "статут (інший засновницький документ)" },
                    { text: "рішення про затвердження;" },
                ]
            },
            {
                title: "2. Дані про керівництво/власників:",
                li: [
                    { text: "паспортні дані та РНОКПП (засновників, бенефіціарів, осіб з правом підпису);" },
                ]
            },
            {
                title: "3. Документи про повноваження:",
                li: [
                    { text: "рішення про призначення Керівника" },
                    { text: "наказ про право підпису" },
                    { text: "довіреність (за наявності);" },
                ]
            },
            {
                title: "4. Фінансова звітність:",
                li: [
                    { text: "звіт про фінансові результати" },
                    { text: "реквізити рахунків в інших банках;" },
                ]
            },
            {
                title: "5. Додатково:",
                li: [
                    { text: "ліцензії (у разі ліцензованої діяльності);" },
                ]
            },
        ]
    },
];
